import * as React from 'react';
import { observer } from 'mobx-react';
import { AssignUserViewStore } from 'nomst/Stores/Configuration/assignUserView.store';
import { AssignedUserLevel } from 'typings/enums';
import { workflowSettingsViewStore } from 'utils/MobxDataManager/singletons';
import { AssignUserView } from 'nomst/Components/WorkflowSettings/assignUserView';
import './hrRolesRow.scss';

interface IHrRolesRowProps {
    assignUserViewStore: AssignUserViewStore;
    assignedUserLevel: AssignedUserLevel;
    readonly?: boolean;
    isUserAlreadyAssigned: (email: string) => boolean;
}

export class HrRolesRow extends React.Component<IHrRolesRowProps> {
    constructor(props: IHrRolesRowProps) {
        super(props);
        this.handleRemoveUser = this.handleRemoveUser.bind(this);
        this.handleAssignUser = this.handleAssignUser.bind(this);
    }

    render(): React.ReactNode {
        const { readonly, assignUserViewStore, isUserAlreadyAssigned } = this.props;

        return (
            <tr className="nomst-hr-roles-row">
                <td>All teams</td>
                <AssignUserView
                    assignUserViewStore={assignUserViewStore}
                    readonly={readonly}
                    includeAllUsers={false}
                    isUserAlreadyAssigned={isUserAlreadyAssigned}
                />
                {this.renderActions()}
            </tr>
        );
    }

    private renderActions(): React.ReactNode {
        const { readonly, assignUserViewStore } = this.props;
        if (readonly || !assignUserViewStore.isUserAssigned) {
            return null;
        }

        return (
            <td className="nomst-hr-roles-row__actions">
                <button
                    className="nomst-hr-roles-row__change-user pxl-link"
                    onClick={this.handleAssignUser}
                >
                    Change
                </button>
                |
                <button
                    className="nomst-hr-roles-row__remove-user pxl-link"
                    onClick={this.handleRemoveUser}
                >
                    Remove
                </button>
            </td>
        );
    }

    private handleAssignUser(): void {
        const { assignUserViewStore } = this.props;
        assignUserViewStore.assignUser();
    }

    private handleRemoveUser(): void {
        const { assignUserViewStore, assignedUserLevel } = this.props;
        workflowSettingsViewStore.removeAssignedUserStore.showRemoveAssignedUserWarningBox(
            assignUserViewStore.selectedUserId ?? '',
            assignedUserLevel);
    }
}

export default observer(HrRolesRow);